module.exports = __webpack_public_path__ + "img/project_statistics.011415ea.png";